namespace Gamification.Gamification {
    export namespace ExtendedEndpointService {
        export const baseUrl = 'Gamification/Extended';

        export declare function InviaMailAttivazione(request: ExtendedStandardRequest, onSuccess?: (response: ExtendedStandardResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            InviaMailAttivazione = "Gamification/Extended/InviaMailAttivazione"
        }

        [
            'InviaMailAttivazione'
        ].forEach(x => {
            (<any>ExtendedEndpointService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
